import Model, { attr } from '@ember-data/model';

export default class TeamSectionRecord extends Model {
	@attr('string') name!: string;
	@attr('string') description!: string;
	@attr('number') position!: number;
	@attr('number') teamId!: number;
}
